module.exports = __webpack_public_path__ + "static/media/lora_co2_modbus.5ea1f56c.md";